import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import Cropper from 'react-cropper'
import 'cropperjs/dist/cropper.css'
import LabelCustomSmall from '../../../label-custom-small'
function ModalCropper({
  setIsSave,
  show,
  handleClose,
  image,
  cropperRef,
  onSaveCrop,
  imgtype,
  isSave
}) {
  return (
    <Modal backdrop="static" className="rounded-4" keyboard={false} show={show}>
      <Modal.Body>
        <p>อัพเดตรูปภาพหน้าตรง (Scan ใบหน้า)</p>
        <div className="mb-3">
          <LabelCustomSmall>{imgtype.detail}</LabelCustomSmall>
        </div>
        <div>
          <Cropper
            src={image}
            style={{ height: 400, width: '100%' }}
            initialAspectRatio={imgtype.x / imgtype.y}
            aspectRatio={imgtype.x / imgtype.y}
            guides={true}
            responsive={false}
            ref={cropperRef}
            autoCropArea={1}
          />
        </div>

        <div className="mt-3 text-center">
          <Button
            disabled={isSave}
            variant="light"
            className="me-2 text-primary px-5 rounded-3"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            disabled={isSave}
            variant="primary"
            className="px-5 rounded-3"
            onClick={async () => {
              await setIsSave(true)
              onSaveCrop()
            }}
          >
            {isSave ? 'Loading...' : 'Save'}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default ModalCropper
